import React, { type ReactElement } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { ZONE_ATTR, ZONE_TYPE_ATTR } from './constants';
import type { ViewDeadAirContentType } from './types';

type ViewDeadAirZoneProps = {
	id: string;
	contentType: ViewDeadAirContentType;
	children: ReactElement;
};

/**
 * Marks a region inside a ViewDeadAirTracker as a zone with specific content type.
 * Mutations inside this zone are tracked with the specified contentType and aggregated by zone ID.
 * - contentType='stream': Consecutive marks with same ID are aggregated (for streaming tokens)
 * - contentType='discrete': Each mark creates a new interval (for distinct updates)
 * This component does NOT create its own MutationObserver - the parent tracker handles observation.
 */
export function ViewDeadAirZone({
	id,
	contentType,
	children,
}: ViewDeadAirZoneProps): React.JSX.Element {
	if (!fg('rovo_chat_track_view_dead_air')) {
		return <>{children}</>;
	}

	return <div {...{ [ZONE_ATTR]: id, [ZONE_TYPE_ATTR]: contentType }}>{children}</div>;
}
